// JoinForm.js
import React, { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import { Circles } from 'react-loader-spinner';
import emailjs from 'emailjs-com';

const JoinForm = () => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    occupation: '',
    company: '', // ⬅️ Add this
    interest: '',
    // involvement: '',
    // joinMailingList: false
  });
  

  const [validator] = useState(new SimpleReactValidator({ className: 'errorMessage' }));

  const changeHandler = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });

    if (validator.allValid()) {
      validator.hideMessages();
    } else {
      validator.showMessages();
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      validator.hideMessages();
      setLoading(true);
  
      try {
        const res = await fetch('/api/submitJoinForm', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            occupation: formData.occupation,
            company: formData.company, // fixed to use company instead of occupation
            interest: formData.interest,
          }),
        });
  
        if (res.ok) {
          // ✅ Prepare message body
          const messageBody = "Thanks for signing up and making a difference! We will reach out shortly to schedule a call and discuss how we plan to make a 4DWW into a reality.";

          // ✅ Send confirmation email via EmailJS
          await emailjs.send(
            process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
            process.env.REACT_APP_EMAILJS_CONFIRMATION_TEMPLATE_ID || '',
            {
              name: formData.name,
              email: formData.email,
              messageBody: messageBody,
            },
            process.env.REACT_APP_EMAILJS_USER_ID || ''
          );
        
          setSubmitted(true);
          setFormData({
            name: '',
            email: '',
            occupation: '',
            company: '',
            interest: '',
            involvement: '',
            joinMailingList: false,
          });
        } else {
          console.error('Submission failed');
        }
      } catch (error) {
        console.error('Error submitting form:', error);
      } finally {
        setLoading(false);
      }
    } else {
      validator.showMessages();
    }
  };  

  return (
    <form onSubmit={submitHandler} className="join-form">
      <div className="form-field">
        <input
          type="text"
          name="name"
          placeholder="Your Name (Required)"
          value={formData.name}
          onChange={changeHandler}
        />
        {validator.message('name', formData.name, 'required|alpha_space')}
      </div>

      <div className="form-field">
        <input
          type="email"
          name="email"
          placeholder="Your Email (Required)"
          value={formData.email}
          onChange={changeHandler}
        />
        {validator.message('email', formData.email, 'required|email')}
      </div>

      <div className="form-field">
        <input
          type="text"
          name="occupation"
          placeholder="Occupation / Industry (Optional)"
          value={formData.occupation}
          onChange={changeHandler}
        />
        {validator.message('occupation', formData.occupation, 'alpha_space')}
      </div>

      <div className="form-field">
        <input
          type="text"
          name="company"
          placeholder="What Company/Public Entity do you Work For? (Optional)"
          value={formData.company}
          onChange={changeHandler}
        />
        {validator.message('company', formData.company, 'alpha_space')}
      </div>

      <div className="form-field">
        <textarea
          name="interest"
          placeholder="Why are you interested in the 4-day work week? (Optional)"
          value={formData.interest}
          onChange={changeHandler}
        />
        {validator.message('interest', formData.interest, 'alpha_space')}
      </div>

      {/* <div className="form-field">
        <select
          name="involvement"
          value={formData.involvement}
          onChange={changeHandler}
        >
          <option value="">How would you like to support?</option>
          <option value="petition">Sign the petition</option>
          <option value="volunteer">Volunteer</option>
          <option value="host">Host an info session</option>
          <option value="stay_informed">Just stay informed for now</option>
        </select>
        {validator.message('involvement', formData.involvement, 'required')}
      </div> */}

      {/* <div className="form-field checkbox">
        <label>
          <input
            type="checkbox"
            name="joinMailingList"
            checked={formData.joinMailingList}
            onChange={changeHandler}
          />
          Join our mailing list
        </label>
      </div> */}

      <div className="submit-area">
        <button type="submit" className="theme-btn" disabled={loading}>
          {loading ? (
            <Circles ariaLabel="loading" color="#ffffff" height="24" width="24" />
          ) : (
            'Join the Movement'
          )}
        </button>
        {submitted && <p className="success-msg">Thanks for joining the movement!</p>}
      </div>
    </form>
  );
};

export default JoinForm;
